import { CUSTOMIZABLE_VALUES, generatedMapStyleJSON, getDefaultValue, getStyleIdExpressions, } from "../variables/layerStylingValues";
export const getMaskProperties = () => {
    var _a;
    return {
        paint: {
            fillColor: (generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.masks)
                ? [
                    "case",
                    ...getStyleIdExpressions(generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.masks.colors),
                    // this is only to prevent "3 arguments, but only got one" error
                    ["==", "s", "d"],
                    "#ffffff",
                    (_a = getDefaultValue(generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.masks.colors)) !== null && _a !== void 0 ? _a : "#333333",
                ]
                : CUSTOMIZABLE_VALUES.masks,
        },
    };
};
